/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import useFetch from 'use-http';
import Styled from '../../UserAccountPage.styles';
import Moment from 'react-moment';
import _ from 'lodash';
import Loader from '../../../../../shared/Loader';
import Page from '../../../../../shared/Page';
import { useTranslation } from 'react-i18next';
import DateRangePicker from '../../../../../shared/DateRangePicker/DateRangePicker';
import { useHistory } from 'react-router-dom';
import {
  useUserState,
  useUserDispatch,
} from '../../../../../context/UserContext';
import { getQueryString } from '../../../../../constants/visitsQueryStringBuilder';
import Button from '../../../../../shared/Button/Button';
import { useEffectOnce } from 'react-use';

const PrescriptionsComponent = () => {
  const { t } = useTranslation();
  const [Prescriptions, setPrescritions] = useState();
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const sessionDispatch = useUserDispatch();
  const userState = useUserState();
  const [search, setSearch] = useState();
  const [dateRange, setDateRange] = useState(userState.dateFilter);
  const { get: getPrescriptions, response: getPrescriptionsResponse } =
    useFetch('/UserAccount/PrescriptionList');

  const { get: getPrescription } = useFetch('/UserAccount/Prescription');

  const applyChanges = async (date, search) => {
    setLoading(true);
    sessionDispatch({
      type: 'UPDATE',
      data: {
        dateFilter: date,
      },
    });
    const response = await getPrescriptions(
      getQueryString(date, search, undefined, undefined, userState.espbiEsi),
    );
    if (getPrescriptionsResponse.status >= 400) {
    } else {
      setPrescritions(response);
    }
    setLoading(false);
  };

  useEffectOnce(() => {
    applyChanges(dateRange, search);
  });

  const handleSelection = async (id) => {
    setLoading(true);
    let query = userState.espbiEsi ?
    `?id=${id}&espbiEsi=${userState.espbiEsi}`
    :
    `?id=${id}`

    await getPrescription(query).then(
      (res) => {
        setLoading(false);
        history.push('/account/prescription', { data: res });
      },
    );
  };
  return (
    <Styled.DataContainer>
      <Styled.TabTitleWrapper>
        <Styled.TabTitle>Receptai</Styled.TabTitle>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            setSearch(e.target.search.value);
            applyChanges(dateRange, e.target.search.value);
          }}
          onChange={(e) => {
            if (
              e.target.value === undefined ||
              e.target.value === null ||
              e.target.value === ''
            ) {
              setSearch(e.target.value);
              applyChanges(dateRange, e.target.value);
            }
          }}
          style={{ display: 'flex' }}
        >
          <input type="text" id="search" placeholder="Paieška" name="search" />
          <Button
            style={{ marginRight: '15px', fontSize: '16px' }}
            size="small"
            type="submit"
          >
            Ieškoti
          </Button>
        </form>
        <DateRangePicker
          dateChanged={(date) => {
            setDateRange(date);
            applyChanges(date, search);
          }}
          dateRange={dateRange}
        />
      </Styled.TabTitleWrapper>
      {loading && (
        <Page>
          <Loader />
        </Page>
      )}
      {!loading &&
        Prescriptions &&
        Prescriptions.length !== 0 &&
        _.orderBy(Prescriptions, ['dateAsserted'], ['desc']).map((obj) => {
          return (
            <div key={obj.id}>
              <Styled.Visit>
                <Styled.VisitTitleDateTime>
                  <a
                    onClick={() => {
                      handleSelection(obj.id);
                    }}
                  >
                    {obj.name}
                  </a>
                  {(new Date(Date.parse(obj.dateAsserted)).getUTCHours() ===
                    0 && (
                    <Moment
                      utc={true}
                      onClick={() => {
                        handleSelection(obj.id);
                      }}
                      className="time"
                      format="YYYY-MM-DD"
                    >
                      {Date.parse(obj.dateAsserted)}
                    </Moment>
                  )) || (
                    <Moment
                      utc={true}
                      onClick={() => {
                        handleSelection(obj.id);
                      }}
                      className="time"
                      format="YYYY-MM-DD HH:mm"
                    >
                      {Date.parse(obj.dateAsserted)}
                    </Moment>
                  )}
                </Styled.VisitTitleDateTime>
                <div>
                  <span>{obj.valid}</span>
                </div>
              </Styled.Visit>
            </div>
          );
        })}
      {Prescriptions && Prescriptions.length !== 0 && !loading && (
        <div style={{ padding: '1.2rem', paddingLeft: '0', fontSize: '14px' }}>
          {t('userAccount.visitHistoryTab.dateInfo')}
        </div>
      )}
      {Prescriptions && Prescriptions.length === 0 && !loading && (
        <>
          <Styled.EmptyList> {t('validation.emptyList')} </Styled.EmptyList>
          <div
            style={{ padding: '1.2rem', paddingLeft: '0', fontSize: '14px' }}
          >
            {t('userAccount.visitHistoryTab.dateInfo')}
          </div>
        </>
      )}
    </Styled.DataContainer>
  );
};
export default PrescriptionsComponent;
